import _ from 'lodash';
import { Box, Typography } from '@mui/material';
import PortalTooltip from '../common/PortalTooltip';
import { faCheckCircle, faCircleXmark } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const getColumns = (columns = [], isAdmin = false) => {
  const defaultColumns = [
    {
      field: 'STATUS',
      headerName: 'Status',
      renderCell: (params) => {
        const error = params.row.ERROR;
        const isError = error && error !== 'null';
        return (
          <PortalTooltip title={isError ? 'Error' : 'Success'}>
            <FontAwesomeIcon
              size="lg"
              icon={isError ? faCircleXmark : faCheckCircle}
              className={isError ? 'myOdu__error' : 'myOdu__success'}
            />
          </PortalTooltip>
        );
      },
    },
  ];

  defaultColumns.push(...columns);

  if (isAdmin) {
    defaultColumns.push({
      field: 'ERROR',
      headerName: 'Error',
      width: 300,
      valueGetter: (params, row) => (_.isPlainObject(row.ERROR) ? row.ERROR.message : row.ERROR),
    });
  }

  return defaultColumns;
};
